import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// Initialize i18n before rendering — must be imported before App
import './@configurations/i18n';
import App from './App';
import UnderConstruction from './views/public/UnderConstruction';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import AuthProvider from '@auth/components/AuthProvider';
import { IS_LOCKED } from '@configurations/Settings';

import './run/setupInterceptors';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {IS_LOCKED === 'Y' ? (
      <UnderConstruction />
    ) : (
      <AuthProvider>
        <App />
      </AuthProvider>
    )}
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
